import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TabKey } from './activity.service';
import { AppLayer } from './layer.service';

@Injectable({
  providedIn: 'root'
})
export class ArchiveModeService {

	archiveModeBS: BehaviorSubject<{isArchive: boolean; disableToggle: boolean;}> = new BehaviorSubject({
		isArchive: false,
		disableToggle: false
	});

	constructor() { }

	// Set archive mode by current tab & layer
	resetArchiveMode(currentTabKey: TabKey, selectedLayer: AppLayer) {
		// const selectedTab = this.activityService.selectedTabBS.getValue();
		// const tabKey = selectedTab ? selectedTab.tabKey : null;
		// const selectedLayer = this.activityService.selectedLayerBS.getValue();
		const layerState = selectedLayer.state;
		if (currentTabKey === 'batch') {
			if (layerState.num < 2) {
				this.archiveModeBS.next({
					isArchive: false,
					disableToggle: true
				});
			} else {
				this.archiveModeBS.next({
					isArchive: this.archiveModeBS.getValue().isArchive,
					disableToggle: false
				});
			}
		} else if (currentTabKey === 'data' || currentTabKey === 'data-addr' || currentTabKey === 'data-centerline') {
			this.archiveModeBS.next({
				isArchive: true,
				disableToggle: true
			});
		}
	}
}
